import React from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import Col from 'muicss/lib/react/col'
import Paper from 'material-ui/Paper'
import { selectPrize } from '../../../../../actions'

const styles = {
  imgContainer: {
    height: '180px',
    width: '150px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
  },
  container: {
    cursor: 'pointer',
    backgroundColor: '#ffffff',
    fontWeight: 'bold',
    margin: '10px',
  },
  paper: {
    borderRadius: '10px',
    padding: '10px',
    border: '1px solid #efefef',
    minHeight: '200px',
    textAlign: 'center',
    overflow: 'hidden',
  },
  credits: {
    borderRadius: 5,
    backgroundColor: '#F58A15',
    textAlign: 'center',
    color: '#fff',
    marginBottom: 5,
  },
}

class Prize extends React.Component {

  render() {
    const { id, image_url, credits, name } = this.props
    const onClick = this.props.selectPrize(this.props)
    return (
      <div
        key={id} style={styles.container}
        onClick={this.handleClick}
      >
        <Paper onClick={onClick} style={styles.paper} className="PaperHover" >
          <Col xs="12" md="6" md-offset="3" style={styles.credits}>
            <FontAwesome name="diamond" />
            {`   ${(credits || 0).toLocaleString()}`}
          </Col>
          <Col style={styles.imgContainer} >
            <img alt="nada" src={image_url} />
          </Col>
          <Col className="mui--align-middle">
            {name}
          </Col>
        </Paper>
      </div>
    )
  }
}


const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  selectPrize: props => () => {
    dispatch(selectPrize(props))
    props.toggleOpen()
  },
})


export default connect(mapStateToProps, mapDispatchToProps)(Prize)



// WEBPACK FOOTER //
// ./src/components/Main/Prizes/PrizeList/Prize/index.jsx